﻿export class request_trip_passenger {
    public trip_passenger_identifier: string | null = null;
    public cancel: boolean = false;
}